import { render, staticRenderFns } from "./Kpi.vue?vue&type=template&id=5a4a8f0b&scoped=true"
import script from "./Kpi.vue?vue&type=script&lang=js"
export * from "./Kpi.vue?vue&type=script&lang=js"
import style0 from "./Kpi.vue?vue&type=style&index=0&id=5a4a8f0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a8f0b",
  null
  
)

export default component.exports